import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocaleDatePipe } from './locale-date.pipe';
import { LocaleNumberPipe } from './locale-number.pipe';

@NgModule({
  declarations: [LocaleDatePipe, LocaleNumberPipe],
  imports: [CommonModule],
  exports: [LocaleDatePipe, LocaleNumberPipe],
})
export class PipesModule {}
